import React, { PropTypes } from "react";
import { FormattedHTMLMessage, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from "redux-form";
import { MessageBox , BSModal, Render } from "../../../common";
import { CheckboxInput, PasswordInput, RadioGroup, SelectInput, TextInput } from "../../../common/form";
import * as loginActions from "../../../login/loginActions";

import * as dataActions from "../../../../utils/data/dataActions";
import { EnumWrapper } from "../../../../utils/enums";
import { LANGUAGE_CODES, ROLES } from "../../../../utils/enums/enums";
import { DIRECTOR, FINTECH, MANAGER, PLAN_ADMINISTRATOR, EXTERNAL_ROLES, roleTypeToId, MENROL_ELIGIBLE_ROLES } from "../../../../utils/Roles";

import { Button } from "react-bootstrap/lib/InputGroup";
import { ACCOUNTBUSINESSUNITS_V2 } from "../../../../utils/data/models";
import userHasAccess from "../../../../utils/userHasAccess";
import validationUtils from "../../../../utils/ValidationUtils";

import { INACTIVE } from "../../clients/enums/clientStatusTypes";
import { ACTIVE } from "./enum/menrolStatusTypes";
import mfaTypes from "./enum/mfaTypes";
import { USER_VALIDATION_RULES } from "./userValidationRules";
import { isAssociatedClientUserReadOnly } from "../../../common/clientHelper";

class BasicUserFields extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isPlanAdministrator: true,
            isActiveMenrolUser: false,
            isMenrolEligibleRole: false,
            showConfirmationModal: false,
        };
        this.changeRole = this.changeRole.bind(this);
        this.changeMenrolStatus = this.changeMenrolStatus.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.openConfirmationModal = this.openConfirmationModal.bind(this);
        this.closeWithConfirmation = this.closeWithConfirmation.bind(this);
        this.closeWithoutConfirmation = this.closeWithoutConfirmation.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.changeBusinessUnit = this.changeBusinessUnit.bind(this);
        this.getClientOptions = this.getClientOptions.bind(this);
    }

    getChildContext() {
        return {
            scene: this.props.scene,
        };
    }

    componentWillMount() {
        this.props.dataActions.getDataList(
            ACCOUNTBUSINESSUNITS_V2,
            0,
            0,
            "",
            ["businessUnitName:asc"],
            "",
            {},
            {},
            "accountBusinessUnitId,businessUnitName"
        );
        const { onEmailChange, initialValues, add, isMenrolEnabled } = this.props;
        onEmailChange && onEmailChange(false);
        this.changeBusinessUnit(initialValues.associatedBu);
        // Default menrol checkbox for eligible roles on creation
        const initialRoleId = initialValues.roleId;
        const isMenrolEligible = MENROL_ELIGIBLE_ROLES.some(r => r.roleId == initialRoleId);
        // Sync Redux Form field value when auto-checking menrol for new eligible users   
        const isAutoCheckedMenrol = add && isMenrolEligible && isMenrolEnabled;
        if (isAutoCheckedMenrol) {
            this.props.changeFieldValue("user", "menrolStatus", true);
        }
        else if (!isMenrolEnabled){
            this.props.changeFieldValue("user","menrolStatus", false);
        }
        this.setState({
            isActiveMenrolUser: initialValues.menrolStatus === ACTIVE.value ||
                isAutoCheckedMenrol,
            isPlanAdministrator: initialRoleId == PLAN_ADMINISTRATOR.roleId,
            isMenrolEligibleRole: isMenrolEligible,
        });
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(ACCOUNTBUSINESSUNITS_V2);
    }

    changeRole(e) {
        const roleId = e.target.value;
        const { isMenrolEnabled } = this.props;
        const isMenrolEligible = MENROL_ELIGIBLE_ROLES.some(r => r.roleId == roleId);
        this.setState({
            isActiveMenrolUser: isMenrolEligible,
            isPlanAdministrator: roleId == PLAN_ADMINISTRATOR.roleId,
            isMenrolEligibleRole: isMenrolEligible,
        });
        
        if(isMenrolEligible && isMenrolEnabled) {
            this.props.changeFieldValue("user", "menrolStatus", true);
        }
        else {
            this.props.changeFieldValue("user", "menrolStatus", null);
        }
        // Clear client selection on role change
        this.props.changeFieldValue("user", "associatedClientIds", null);
    }
    changeMenrolStatus(e) {
        this.setState({ isActiveMenrolUser: e.target.checked });
    }

    setPassword(value) {
        this.props.changeFieldValue("user", "isPasswordSet", value);
    }

    changeBusinessUnit(businessUnits) {
        const businessUnitsList = businessUnits
            .filter((element) => typeof element === "object")
            .map((element) => element.accountBusinessUnitId);
        const associatedBu = businessUnitsList.length > 0 ? businessUnitsList : businessUnits;

        this.props.changeFieldValue("user", "associatedBu", associatedBu);
    }

    handlePasswordChange() {
        return (value) => {
            if (value !== "" && value !== this.props.initialValues.mockPassword) {
                this.setPassword(true);
            } else {
                this.setPassword(false);
            }
            return value;
        };
    }

    openConfirmationModal() {
        this.setState({ showConfirmationModal: true });
    }

    closeWithoutConfirmation() {
        this.setState({ showConfirmationModal: false });
    }

    closeWithConfirmation() {
        this.setState({ showConfirmationModal: false });
        const user_data = {
            emailAddress: this.props.initialValues.emailAddress,
            username: this.props.initialValues.username,
        };
        return this.props.loginActions.initiatePasswordReset(user_data);
    }

    onEmailChange(event, newValue) {
        const { initialValues, add } = this.props;
        let isEmailChanged = false;
        if (!add) {
            if (initialValues.emailAddress != newValue) isEmailChanged = true;
            this.props.onEmailChange(isEmailChanged);
        }
    }

    getClientOptions(clients) {
        let clientArray = clients;
        const { roleId } = this.props;

        clientArray = clientArray.filter((c) => !isAssociatedClientUserReadOnly(c, roleId));
        clientArray = clientArray.map((c) => {
            return {
                value: c.clientId,
                text: c.name,
            };
        });

        return clientArray;
    }

    render() {
        const { add, isMenrolEnabled } = this.props;
        let { clients } = this.props;
        const { disabled, restrictedClientUser } = this.props;
        const roleId = parseInt(this.props.roleId);
        const { accountBusinessUnits } = this.props;

        const isManager = userHasAccess(MANAGER, true);
        const isCreation = this.props.add;
        const isMenrolEligibleRole = MENROL_ELIGIBLE_ROLES.some(r => r.roleId == roleId);
        const isSuperUser = userHasAccess(FINTECH);
        const hasManagerAccess = userHasAccess(MANAGER);
        const hasCoordinatorAccess = userHasAccess(DIRECTOR);
        const isCurrentUserAssociatedToOnlyOneBU = this.props.currentUserAssociatedBu.length == 1;
        const clientAssociated = roleTypeToId(EXTERNAL_ROLES).indexOf(roleId) >= 0;
        const hasAccountBusinessUnits =
            accountBusinessUnits && accountBusinessUnits.items && accountBusinessUnits.items.length > 0;
        const userIsArchived = this.props.initialValues.isArchived;
        const cannotModifyRole =
            disabled ||
            restrictedClientUser ||
            (!!this.props.initialValues.userId && this.props.initialValues.authUser === this.props.initialValues.userId) ||
            (!isSuperUser && !isCreation) ||
            isManager
        if (isCurrentUserAssociatedToOnlyOneBU) {
            this.props.changeFieldValue(
                "user",
                "associatedBu",
                this.props.currentUserAssociatedBu[0].accountBusinessUnitId.toString()
            );
        }
        if (!isSuperUser && add) {
            clients = clients.filter((client) => client.clientStatusType != INACTIVE.value);
        }
        return (
            <div>
                {hasAccountBusinessUnits && (
                    <form onSubmit={this.props.handleSubmit}>
                        {isSuperUser && (
                            <Field
                                id="username"
                                name="username"
                                component={TextInput}
                                type="text"
                                label={<FormattedMessage id="admin.users.form.username" />}
                                disabled={disabled || !isCreation}
                            />
                        )}
                        <Field
                            id="emailAddress"
                            name="emailAddress"
                            component={TextInput}
                            type="text"
                            required={true}
                            label={<FormattedMessage id="admin.users.form.emailAddress" />}
                            onChange={this.onEmailChange}
                            disabled={disabled}
                        />

                        <Field
                            id="firstName"
                            name="firstName"
                            component={TextInput}
                            type="text"
                            required={true}
                            label={<FormattedMessage id="admin.users.form.firstName" />}
                            disabled={disabled || (!isSuperUser && !isCreation)}
                        />

                        <Field
                            id="lastName"
                            name="lastName"
                            component={TextInput}
                            type="text"
                            required={true}
                            label={<FormattedMessage id="admin.users.form.lastName" />}
                            disabled={disabled || (!isSuperUser && !isCreation)}
                        />

                        <Field
                            id="phone"
                            name="phone"
                            component={TextInput}
                            type="text"
                            label={<FormattedMessage id="admin.users.form.phone" />}
                            disabled={disabled || (!hasManagerAccess && !isCreation)}
                        />

                        {!clientAssociated && (
                            <Field
                                id="mfaType"
                                name="mfaType"
                                groupClassName="multi-row-label"
                                component={SelectInput}
                                label={<FormattedMessage id="admin.users.form.mfa" />}
                                options={mfaTypes}
                                required={true}
                                disabled={disabled || !hasCoordinatorAccess}
                            />
                        )}

                        {isSuperUser && (
                            <Field
                                id="password"
                                name="password"
                                component={PasswordInput}
                                type="password"
                                fieldDescription={<FormattedHTMLMessage id="validation.customMessages.passwordRules" />}
                                disabled={disabled}
                                mockPassword={this.props.initialValues.mockPassword || ""}
                                label={<FormattedMessage id="admin.users.form.password" />}
                                normalize={this.handlePasswordChange("isPasswordSet")}
                            />
                        )}
                        {isSuperUser && (
                            <Field
                                id="isPasswordSet"
                                name="isPasswordSet"
                                component="input"
                                type="hidden"
                                disabled={disabled}
                            />
                        )}

                        <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
                            <Field
                                id="languageCode"
                                name="languageCode"
                                component={SelectInput}
                                label={<FormattedMessage id="admin.users.form.language" />}
                                disabled={disabled || (!hasManagerAccess && !isCreation)}
                            />
                        </EnumWrapper>
                        <EnumWrapper enum={ROLES} format="inputs" prop="radios">
                            <Field
                                id="roleId"
                                name="roleId"
                                groupClassName="user-roles"
                                component={RadioGroup}
                                props={{ onChange: this.changeRole }}
                                required={true}
                                disabled={cannotModifyRole}
                                label={<FormattedMessage id="admin.users.form.role" />}
                                externalRoleIds = {roleTypeToId(EXTERNAL_ROLES)}
                            />
                        </EnumWrapper>

                        {restrictedClientUser && isCreation && (
                            <MessageBox className="alert-warning">
                                <FormattedMessage id="admin.users.form.clientUserCreationNote" />
                            </MessageBox>
                        )}

                        {!isCurrentUserAssociatedToOnlyOneBU && !clientAssociated && (
                            <Field
                                id="associatedBu"
                                name="associatedBu"
                                component={SelectInput}
                                multi={true}
                                label={<FormattedMessage id="admin.users.form.businessAccount" />}
                                options={accountBusinessUnits.items.map((accountBusinessUnit) => ({
                                    value: accountBusinessUnit.accountBusinessUnitId,
                                    text: accountBusinessUnit.businessUnitName,
                                }))}
                                disabled={!isSuperUser && !isCreation}
                            />
                        )}
                        {clientAssociated && (
                            <div className="associatedClientIdsDropDown">
                                <Field
                                    id="associatedClientIds"
                                    name="associatedClientIds"
                                    component={SelectInput}
                                    multi={true}
                                    clearable={true}
                                    searchable={true}
                                    sortOptions={true}
                                    disabled={disabled || isManager}
                                    label={<FormattedMessage id="admin.users.form.associatedClientId" />}
                                    options={this.getClientOptions(clients)}
                                />
                            </div>
                        )}
                        {isMenrolEligibleRole && isMenrolEnabled && (
                                <Field
                                    id="menrolStatus"
                                    name="menrolStatus"
                                    component={CheckboxInput}
                                    disabled={disabled || this.props.initialValues.isArchived}
                                    type="checkbox"
                                    checkbox={{ value: true }}
                                    props={{ onChange: this.changeMenrolStatus }}
                                    checked={this.state.isActiveMenrolUser}
                                    label={<FormattedMessage id="admin.users.form.menrolAccess" />}
                                />
                            )}
                        {!isCreation && !disabled && !userIsArchived && (
                            <div>
                                <Button
                                    ref="action"
                                    className={"reverse-reload-borderless-button btn btn-xs btn-primary"}
                                    onClick={this.openConfirmationModal}
                                >
                                    <FormattedMessage id="admin.users.form.resetPassword" />
                                </Button>
                                <Render if={this.state.showConfirmationModal}>
                                    <BSModal
                                        show={this.state.showConfirmationModal}
                                        title={
                                            <FormattedMessage id="admin.users.form.confirmationTitle">
                                                {(f) => <span className="icon warning">{f}</span>}
                                            </FormattedMessage>
                                        }
                                        closeButtonKey="common.close"
                                        onClose={this.closeWithoutConfirmation}
                                        actions={[
                                            {
                                                id: 1,
                                                text: <FormattedMessage id="common.confirm" />,
                                                action: this.closeWithConfirmation,
                                            },
                                        ]}
                                    >
                                        <FormattedMessage
                                            id="admin.users.form.passwordResetConfirmation"
                                            values={{ email: this.props.initialValues.emailAddress }}
                                        />
                                    </BSModal>
                                </Render>
                            </div>
                        )}
                    </form>
                )}
            </div>
        );
    }
}

BasicUserFields.propTypes = {
    changeFieldValue: PropTypes.func.isRequired,
    loginActions: PropTypes.object,
    clients: PropTypes.array.isRequired,
    initialValues: PropTypes.object,
    mockPassword: PropTypes.string,
    roleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scene: PropTypes.string,
    validation: PropTypes.object,
    handleSubmit: PropTypes.func,
    disabled: PropTypes.bool,
    restrictedClientUser: PropTypes.bool,
    accountBusinessUnits: PropTypes.object,
    currentUserAssociatedBu: PropTypes.array,
    add: PropTypes.bool,
    onEmailChange: PropTypes.func,
    dataActions: PropTypes.object,
    activeClient: PropTypes.object,
    isMenrolEnabled: PropTypes.bool,
};

BasicUserFields.defaultProps = {
    scene: "",
    disabled: false,
};

BasicUserFields.contextTypes = {
    getData: PropTypes.func,
    intl: intlShape,
};

BasicUserFields.childContextTypes = {
    scene: PropTypes.string,
};

function mapStateToProps(state) {
    const selector = formValueSelector("user");
    const accountBusinessUnits = state.data.accountBusinessUnits;
    const currentUserAssociatedBu = state.auth.user.relationships.associatedBu.object;
    return {
        currentUserAssociatedBu: currentUserAssociatedBu,
        accountBusinessUnits: accountBusinessUnits,
        roleId: selector(state, "roleId"),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
        loginActions: bindActionCreators(loginActions, dispatch),
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "user",
        validate: (values) => validationUtils.validate(values, USER_VALIDATION_RULES),
    })(BasicUserFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/users/BasicUserFields.js